import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

import { StyledLabel } from './styles';


interface LabelProps {

    children?: any,
    color?: any,
    variant?: any,
    startIcon?: any,
    endIcon?: any,
    sx?: any,
    other?:any
}

const Label = forwardRef<unknown, LabelProps>(({
    children, color = 'default', variant = 'soft', startIcon, endIcon, sx, ...other }, ref) => {
        const theme = useTheme();

        const iconStyles = {
          width: 16,
          height: 16,
          '& svg, img': { width: 1, height: 1, objectFit: 'cover' },
        };

        return (
          <StyledLabel
            ref={ref}
            component="span"
            ownerState={{ color, variant }}
            sx={{
              ...(startIcon && { pl: 0.75 }),
              ...(endIcon && { pr: 0.75 }),
              ...sx,
            }}
            theme={theme}
            {...other}
          >
            {startIcon && <Box sx={{ mr: 0.75, ...iconStyles }}> {startIcon} </Box>}

            {children}

            {endIcon && <Box sx={{ ml: 0.75, ...iconStyles }}> {endIcon} </Box>}
          </StyledLabel>
        );
})



Label.propTypes = {
    children: PropTypes.node,
    endIcon: PropTypes.object,
    startIcon: PropTypes.object,
    sx: PropTypes.object,
    variant: PropTypes.oneOf(['filled', 'outlined', 'ghost', 'soft']),
    color: PropTypes.oneOf([
      'default',
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'error',
    ]),
};


export default Label